import './MiniProgressBar.css';

export interface MiniProgressBarProps {
  /** Fração das seções totalizadas (0 a 1). */
  sectionsFraction: number;
  /** `thin` = 2 px de altura (linhas de UF); padrão 3 px. */
  variant?: 'default' | 'thin';
}

function frac(v: number): number {
  if (!Number.isFinite(v) || v <= 0) return 0;
  return Math.round(Math.min(v, 1) * 1e6) / 1e6;
}

/** Progresso das seções em 34×3 px (§3.8 `MiniProgressBar`); decorativo, o % está no nome da linha. */
export function MiniProgressBar({ sectionsFraction, variant = 'default' }: MiniProgressBarProps) {
  const w = frac(sectionsFraction);
  const state = w === 0 ? 'empty' : w === 1 ? 'complete' : 'partial';
  return (
    <span
      class={variant === 'thin' ? 'mini-progress-bar mini-progress-bar--thin' : 'mini-progress-bar'}
      data-testid="mini-progress-bar"
      data-state={state}
      data-dataviz=""
      aria-hidden="true"
    >
      <span class="mini-progress-bar__fill" style={{ '--w': String(w) }} />
    </span>
  );
}
